/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P2_Free_TitleInputs */

const en_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supercharge Your Focus in Every Way`)
};

const ar_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشحن تركيزك بشكل فائق في كل شيء`)
};

const de_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Fokus wird in jeder Hinsicht verbessert`)
};

const es_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potencia tu concentración en todos los sentidos`)
};

const fr_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimisez votre concentration à tous les niveaux`)
};

const it_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potenzia la tua concentrazione in ogni modo`)
};

const ja_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あらゆる方法で集中力を高めましょう`)
};

const ko_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 면에서 집중력을 향상시키세요`)
};

const pt_br_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incremente seu foco de todas as formas`)
};

const ru_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повышайте фокусировку во всех сферах`)
};

const th_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกระดับการโฟกัสของคุณในทุก ๆ ด้าน`)
};

const tr_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmanı Her Yönden Güçlendir`)
};

const zh_cn_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 Plus，专注体验
全方位升级！`)
};

const zh_tw_subscription_walkthrough_p2_free_title = /** @type {(inputs: Subscription_Walkthrough_P2_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 Plus，專注體驗
全方位升級！`)
};

/**
* | output |
* | --- |
* | "Supercharge Your Focus in Every Way" |
*
* @param {Subscription_Walkthrough_P2_Free_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p2_free_title = /** @type {((inputs?: Subscription_Walkthrough_P2_Free_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P2_Free_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "de") return de_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "es") return es_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "it") return it_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "th") return th_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p2_free_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p2_free_title(inputs)
	return zh_tw_subscription_walkthrough_p2_free_title(inputs)
});